import React, { useState } from 'react';
import logo from '../logo_blade.png';
import { auth, db } from '../services/firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

function LoginBarbearia({ onLogin, onCadastro, onVoltar, onEmailNaoVerificado }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  async function handleLogin() {
    if (!email || !senha) {
      setErro('Preencha todos os campos');
      return;
    }
    setCarregando(true);
    setErro('');
    try {
      const resultado = await signInWithEmailAndPassword(auth, email, senha);
      const uid = resultado.user.uid;

      // E-mail precisa estar verificado antes de entrar (espelha o cliente)
      if (!resultado.user.emailVerified) {
        await auth.signOut();
        onEmailNaoVerificado(email);
        setCarregando(false);
        return;
      }

      // Verifica se é uma barbearia cadastrada
      const docRef = doc(db, 'barbearias', uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        setErro('Conta não encontrada. Cadastre sua barbearia.');
        setCarregando(false);
        return;
      }

      const barbearia = docSnap.data();

      if (barbearia.status === 'pendente') {
        setErro('Sua barbearia ainda está aguardando aprovação. Em até 24h você receberá a confirmação.');
        setCarregando(false);
        return;
      }

      onLogin({ ...barbearia, uid });
    } catch (e) {
      setErro('Email ou senha incorretos');
    }
    setCarregando(false);
  }

  async function handleEsqueciSenha() {
    setErro('');
    setMensagem('');
    if (!email) {
      setErro('Digite seu email para receber o link de redefinição');
      return;
    }
    setCarregando(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setMensagem('Enviamos um link de redefinição para seu email. Verifique a caixa de entrada e o spam.');
    } catch (e) {
      if (e.code === 'auth/invalid-email') {
        setErro('Email inválido');
      } else {
        setErro('Não foi possível enviar o link. Tente novamente.');
      }
    }
    setCarregando(false);
  }

  const inputStyle = {
    width: '100%', padding: '14px', borderRadius: '10px',
    border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
    color: '#e8e8e8', fontSize: '15px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Arial, sans-serif'
  };

  const labelStyle = {
    fontSize: '11px', color: '#9c9c9c', letterSpacing: '1px',
    textTransform: 'uppercase', display: 'block', marginBottom: '6px'
  };

  return (
    <div style={{
      backgroundColor: '#111111', minHeight: '100vh',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'space-between',
      fontFamily: 'Arial, sans-serif', padding: '60px 24px 40px'
    }}>

      <img src={logo} alt="BLADE" style={{ width: '140px', cursor: 'pointer' }} onClick={onVoltar} />

      <div style={{ width: '100%' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
          <span onClick={onVoltar} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
          <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#e8e8e8', margin: 0 }}>
            Acesso da barbearia
          </h2>
        </div>
        <p style={{ fontSize: '13px', color: '#8f8f8f', marginBottom: '28px', paddingLeft: '32px' }}>
          Entre com o email cadastrado
        </p>

        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Email</label>
          <input
            type="email" placeholder="seu@email.com" value={email}
            onChange={e => setEmail(e.target.value)} style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '8px' }}>
          <label style={labelStyle}>Senha</label>
          <input
            type="password" placeholder="••••••••" value={senha}
            onChange={e => setSenha(e.target.value)} style={inputStyle}
          />
        </div>

        <p
          onClick={carregando ? undefined : handleEsqueciSenha}
          style={{
            textAlign: 'right', fontSize: '12px', color: '#7bc47b',
            cursor: carregando ? 'default' : 'pointer', margin: '0 0 8px',
            textDecoration: 'underline'
          }}>
          Esqueci minha senha
        </p>

        {mensagem && (
          <div style={{
            backgroundColor: '#0a1a0a', border: '0.5px solid #2d4a2d',
            borderRadius: '8px', padding: '10px 14px', marginBottom: '12px', marginTop: '8px'
          }}>
            <p style={{ fontSize: '12px', color: '#7bc47b', margin: 0, lineHeight: '1.5' }}>{mensagem}</p>
          </div>
        )}

        {erro && (
          <div style={{
            backgroundColor: '#1a0a0a', border: '0.5px solid #4a1a1a',
            borderRadius: '8px', padding: '10px 14px', marginBottom: '12px', marginTop: '8px'
          }}>
            <p style={{ fontSize: '12px', color: '#e24b4a', margin: 0, lineHeight: '1.5' }}>{erro}</p>
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={carregando}
          style={{
            width: '100%', backgroundColor: carregando ? '#1a2a1a' : '#2d4a2d',
            color: '#7bc47b', border: 'none', borderRadius: '12px', padding: '16px',
            fontSize: '15px', fontWeight: '600', cursor: carregando ? 'default' : 'pointer',
            fontFamily: 'Arial, sans-serif', marginTop: '16px', marginBottom: '14px'
          }}>
          {carregando ? 'Entrando...' : 'Entrar'}
        </button>

        <div style={{ height: '0.5px', backgroundColor: '#1e1e1e', margin: '20px 0' }} />

        <p style={{ textAlign: 'center', fontSize: '13px', color: '#8f8f8f', marginBottom: '12px' }}>
          Ainda não tem cadastro?
        </p>
        <button onClick={onCadastro} style={{
          width: '100%', backgroundColor: 'transparent',
          color: '#3d6b3d', border: '0.5px solid #2d4a2d',
          borderRadius: '12px', padding: '14px', fontSize: '14px',
          cursor: 'pointer', fontFamily: 'Arial, sans-serif'
        }}>
          Cadastrar minha barbearia
        </button>
      </div>

      <p style={{ fontSize: '11px', color: '#333', textAlign: 'center' }}>
        BLADE — Painel da barbearia
      </p>
    </div>
  );
}

export default LoginBarbearia;